module.exports = __webpack_public_path__ + "img/stream.30c8354a.jpeg";